import React from "react"
import Section from "../blocks/section"
import DfbButton from "../ui-kit/dfb_button"

function MButton({ data }: {
  data: {
    link_text: string,
    link_obj: { url: string },
  } & Record<string, string>
}) {
  const { link_text, link_obj } = data
  return (
    <Section data={data} defaultPadding="small">
      <div className="u-Wrapper">
        <div className="u-Container">
          <div className="u-Content" style={{ textAlign: "center" }}>
            <DfbButton
              text={link_text}
              link={link_obj.url}
              tagName="a"
            />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MButton